import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbQueryhistoryApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'dbQueryhistory';
    }

    /**
     * 根据用户获取SQL历史记录
     * @param userId 
     * @param devProd 
     * @returns 
     */
    public getDbQueryhistorysByUserId(userId: number, devProd: string) {
        return this.send({ userId, devProd }, "getDbQueryhistorysByUserId", Methods.GET);
    }

    /**
     * 批量新增或修改
     * @param datas 
     * @returns 
     */
    public dbQueryhistorySaveOrUpdate(datas) {
        return this.send(datas, "dbQueryhistorySaveOrUpdate", Methods.POST);
    }

    /**
     * 新增或修改
     * @param data 
     * @returns 
     */
    public saveOrUpdate(data) {
        return this.send(data, "saveOrUpdate", Methods.POST);
    }
}